import { City } from 'model/business-keywords';
import { UserContact } from 'model/business-types';

export abstract class GeneralLookupsApi {
  abstract lookupUsers(filter: LookupFilter): Promise<UserContact[]>;
  abstract lookupCities(filter: LookupFilter): Promise<City[]>;
}

export interface LookupFilter {
  text: string | null;
}
